import { deserialize } from 'class-transformer';

function fileteredDeserialization(json, model) {
  const object = JSON.parse(json);
  const filtered = filterInstanceProperties(object, model);
  const instance = new model();
  const deserializedInstance = deserialize(model, JSON.stringify(filtered));
  // Workaround for a 'deserialize' function bug:
  // it seems to remember previous deserialized model properties
  // and adds them to the current deserialization with undefined values.
  safeCopy(instance, deserializedInstance);
  return instance;
}

function filterInstanceProperties(object, model) {
  const props = Object.getOwnPropertyNames(new model());
  const retObj = {};
  for (const prop of props) {
    if (object[prop] != undefined
          && model.allowedInstanceProperties.includes(prop.toString())) {
      retObj[prop] = object[prop];
    }
  }
  return retObj;
}

function safeCopy(target, source) {
  const model = target.constructor;
  const props = Object.getOwnPropertyNames(new model());
  for (const prop of props) {
    if (source[prop] != undefined
          && model.allowedInstanceProperties.includes(prop.toString())) {
      target[prop] = source[prop];
    }
  }
}

function simplyDeserialize(model, source) {
  const newObject = new model();
  const props = Object.getOwnPropertyNames(newObject);
  for (const prop of props) {
    if (source[prop] != undefined
          && model.allowedInstanceProperties.includes(prop.toString())) {
      newObject[prop] = source[prop];
    }
  }
  return newObject;
}

export {
  fileteredDeserialization, safeCopy, filterInstanceProperties, simplyDeserialize,
};
